import idx from "idx"

import { getSafeDataMap } from "@jsUtils"

function transform(supportData, relatedPages, currentPage, styles) {
  const supportItems = idx(supportData, _ => _.supportItems)
  const slug = currentPage

  const otherRaw = getSafeDataMap(relatedPages, i => i)

  const otherPages = otherRaw.sort((a, b) => {
    if (a.slug < b.slug) {
      return -1
    }
    if (b.slug < a.slug) {
      return 1
    }
    return 0
  })

  const items = getSafeDataMap(supportItems, i => {
    return {
      summary: idx(i, _ => _.title),
      style: styles.inside,
      content: idx(i, _ => _.content.childMarkdownRemark.html),
      id: idx(i, _ => _.id)
    }
  })

  return {
    slug,
    otherPages,
    data: items
  }
}

export default {
  transform
}
